// -------------------------
// GLOBAL SHIM (required)
// Must be FIRST import
// -------------------------
import "@/shims/global";

import "reflect-metadata";
import AuthenticationService, {
  AuthenticationServiceStartupState,
} from "@HisPlatform/Services/Implementation/Authentication/AuthenticationService";
import QueuedLogger from "@HisPlatform/Services/Definition/Logger/QueuedLogger";

const queuedLogger = new QueuedLogger();
const authenticationService = new AuthenticationService(queuedLogger);

addEventListener("load", async () => {
  console.log("MedWorkS - starting up...");

  const state = await authenticationService.startupAsync();

  switch (state) {
    case AuthenticationServiceStartupState.InProgress:
      (window as any).application.showLoader();
      break;

    case AuthenticationServiceStartupState.Idle:
    case AuthenticationServiceStartupState.Success:
      try {
        (window as any).application.showLoader();

        // Dynamically load the main platform bundle
        const mainModule = await import("./his-platform");
        mainModule.default(authenticationService);
      } finally {
        (window as any).application.hideLoader();
      }
      break;
  }
});

export { authenticationService };